/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { LocationListEntryFromJSON, LocationListEntryToJSON, MetaDataFromJSON, MetaDataToJSON, PageRequestFromJSON, PageRequestToJSON, } from './';
export function PagedResponseOfLocationListEntryFromJSON(json) {
    return PagedResponseOfLocationListEntryFromJSONTyped(json, false);
}
export function PagedResponseOfLocationListEntryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'nextPage': !exists(json, 'nextPage') ? undefined : PageRequestFromJSON(json['nextPage']),
        'metaData': !exists(json, 'metaData') ? undefined : MetaDataFromJSON(json['metaData']),
        'numberOfElements': !exists(json, 'numberOfElements') ? undefined : json['numberOfElements'],
        'entries': !exists(json, 'entries') ? undefined : (json['entries'].map(LocationListEntryFromJSON)),
        'totalElements': !exists(json, 'totalElements') ? undefined : json['totalElements'],
        'hasNext': !exists(json, 'hasNext') ? undefined : json['hasNext'],
        'hasPrevious': !exists(json, 'hasPrevious') ? undefined : json['hasPrevious'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'previousPage': !exists(json, 'previousPage') ? undefined : PageRequestFromJSON(json['previousPage']),
        'size': !exists(json, 'size') ? undefined : json['size']
    };
}
export function PagedResponseOfLocationListEntryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'nextPage': PageRequestToJSON(value.nextPage),
        'metaData': MetaDataToJSON(value.metaData),
        'numberOfElements': value.numberOfElements,
        'entries': value.entries === undefined ? undefined : (value.entries.map(LocationListEntryToJSON)),
        'totalElements': value.totalElements,
        'hasNext': value.hasNext,
        'hasPrevious': value.hasPrevious,
        'page': value.page,
        'previousPage': PageRequestToJSON(value.previousPage),
        'size': value.size
    };
}
